import { put, call } from "redux-saga/effects";
import { push } from 'react-router-redux';
import Swal from "sweetalert2";
import {
    getUserSuccess,
    getUserFail,
    getAllUsersSuccess,
    getAllUsersFail,
    getUsersByStatusSuccess,
    getUsersByStatusFail,
    getUsersByJobSuccess,
    getUsersByJobFail,
    getUsersByEntitySuccess,
    getUsersByEntityFail,
    createUserSuccess,
    createUserFail,
    updateUserSuccess,
    updateUserFail,
    updateUserAccountStatusSuccess,
    updateUserAccountStatusFail,
    deleteUserSuccess,
    deleteUserFail,
    assignRolesSuccess,
    assignRolesFail,
    removeRolesSuccess,
    removeRolesFail,
    setLoading
    ,
    massImportUsersSuccess,
    massImportUsersFail,
    downloadUsersTemplateFail,
    downloadUsersTemplateSuccess,
    reviewUsersMassImportSuccess,
    reviewUsersMassImportFail,
    importUsersMassSuccess,
    importUsersMassFail,
    getTrombinoscopeFailure,
    getTrombinoscopeSuccess,
    getUserJobHistoryFailure,
    getUserJobHistorySuccess,
    getDirectReportsFail,
    getDirectReportsSuccess,
    uploadUserPhotoFail,
    uploadUserPhotoSuccess,
    deleteUserPhotoFail,
    deleteUserPhotoSuccess,
    updateMyProfileFail,
    updateMyProfileSuccess,
    uploadAttestationRibFail,
    uploadAttestationRibSuccess,
    EXPORT_USERS_SUCCESS,
    EXPORT_USERS_FAIL,
    getAllUsersRequest

} from "../actions/userActions";
import { downloadBlob } from "./formationsSaga";
import {

    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest, getBlobRequest, extractErrorMessage
} from "../../../api";
import { logout, setAuthenticatedUser } from "../actions/authActions";



// ========================================
// 📥 SAGA - review && add   users
// ========================================
export function* reviewUsersMassImportSaga(action) {
    const rawToken = sessionStorage.getItem("token");
    const token = rawToken?.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;
    const uid = sessionStorage.getItem("uid");
    const selectedCompanyId = sessionStorage.getItem("selectedCompanyId");

    const { companyId, action: mode, rows } = action.payload;

    const url = `${API_BASE_URL}/api/users/mass/${companyId}/${mode}/review`;

    yield put(setLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: rows,
            token,
            extraHeaders: { uid, "X-Tenant-Id": selectedCompanyId },
        });

        yield put(reviewUsersMassImportSuccess(resp.data));
        yield put(setLoading(false));
    } catch (e) {
        yield put(reviewUsersMassImportFail(e.message));
        yield put(setLoading(false));
    }
}
export function* getUserJobHistorySaga(action) {
    const userId = action.payload?.userId;
    const url = `${API_BASE_URL}/api/users/${userId}/job-history`;

    if (!userId) {
        yield put(getUserJobHistoryFailure("unknown", "userId manquant"));
        return;
    }

    try {
        console.group("🔵 GET_USER_JOB_HISTORY_REQUEST");
        console.log("👤 userId:", userId);
        console.log("🌐 URL:", url);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group("✅ GET_USER_JOB_HISTORY_SUCCESS");
        console.log("📥 items:", resp.data?.length || 0);
        console.groupEnd();

        yield put(getUserJobHistorySuccess(userId, resp.data || []));
    } catch (error) {
        console.group("❌ GET_USER_JOB_HISTORY_FAIL");
        console.error("🚨 Erreur:", error?.message);
        console.groupEnd();

        yield put(getUserJobHistoryFailure(userId, error?.message || "Erreur"));
    }
}
export function* getTrombinoscopeSaga(action) {
    const url = `${API_BASE_URL}/api/users/trombinoscope`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_TROMBINOSCOPE_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.log('🌐 URL:', url);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_TROMBINOSCOPE_SUCCESS');
        console.log('📥 Nombre d\'utilisateurs:', resp.data?.length || 0);
        console.groupEnd();

        yield put(getTrombinoscopeSuccess(resp.data || []));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_TROMBINOSCOPE_FAIL');
        console.error('🚨 Erreur:', error?.message);
        console.groupEnd();

        yield put(getTrombinoscopeFailure(error?.message || "Erreur"));
        yield put(setLoading(false));
    }
}

export function* importUsersMassSaga(action) {
    const rawToken = sessionStorage.getItem("token");
    const token = rawToken?.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;
    const uid = sessionStorage.getItem("uid");
    const selectedCompanyId = sessionStorage.getItem("selectedCompanyId");

    const { companyId, action: mode, rows } = action.payload;

    const url = `${API_BASE_URL}/api/users/mass/${companyId}/${mode}`;

    yield put(setLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: rows,
            token,
            extraHeaders: { uid, "X-Tenant-Id": selectedCompanyId },
        });

        yield put(importUsersMassSuccess(resp.data));
        yield put(getAllUsersRequest());
        yield put(setLoading(false));
    } catch (e) {
        yield put(importUsersMassFail(e.message));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: e.message || "Erreur import massif",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}


// ========================================
// 📥 SAGA - Télécharger template users
// ========================================



export function* downloadUsersTemplateSaga(action) {
    const rawToken = sessionStorage.getItem("token"); // ex: "xxxx"
    const uid = sessionStorage.getItem("uid");
    // const selectedCompanyId = sessionStorage.getItem("selectedCompanyId");

    // ✅ IMPORTANT: ton backend attend Authorization au format Bearer
    const token = rawToken?.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;

    const url = `${API_BASE_URL}/api/users/template`;

    yield put(setLoading(true));

    try {
        if (!uid) throw new Error("uid introuvable dans sessionStorage");

        const resp = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        // ✅ Télécharger le fichier
        const blob = new Blob([resp.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName = "users_import_template.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();

        yield put(downloadUsersTemplateSuccess());
        yield put(setLoading(false));

    } catch (error) {
        yield put(downloadUsersTemplateFail(error.message));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: error.message || "Erreur téléchargement template",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}

// ========================================
// 📥 SAGA - Ajouter le users en mass
// ========================================

export function* massImportUsersSaga(action) {
    const token = sessionStorage.getItem("token");
    const { companyId, action: importAction, users } = action.payload;

    const url = `${API_BASE_URL}/api/users/mass/${companyId}/${importAction}`;
    yield put(setLoading(true));

    try {
        console.group("🔵 MASS_IMPORT_USERS_REQUEST");
        console.log("🏢 Company ID:", companyId);
        console.log("⚙️ Action:", importAction);
        console.log("👥 Rows:", users?.length || 0);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data: users, token });

        console.group("✅ MASS_IMPORT_USERS_SUCCESS");
        console.log("📥 Imported users:", resp.data?.length || 0);
        console.groupEnd();

        yield put(massImportUsersSuccess(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Import effectué avec succès",
            timer: 2000,
            showConfirmButton: false,
        });

        if (action.history) {
            yield put(push("/users"));
        }
    } catch (error) {
        console.group("❌ MASS_IMPORT_USERS_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(massImportUsersFail(error.message));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur lors de l'import",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}
// ========================================
// 📥 SAGA - Récupérer un utilisateur par ID
// ========================================


export function* getUserSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_USER_REQUEST');
        console.log('📊 User ID:', action.payload.userId);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_USER_SUCCESS');
        console.log('📥 User récupéré:', resp.data);
        console.groupEnd();

        // ✅ Mettre à jour le reducer user
        yield put(getUserSuccess(resp.data));

        // Restore auth user if the fetched user matches the currently logged in session
        if (resp.data && String(resp.data.id) === String(sessionStorage.getItem('uid'))) {
            yield put(setAuthenticatedUser(resp.data));
        }

        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_USER_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        const requestedUserId = String(action.payload.userId);
        const sessionUserId = String(sessionStorage.getItem('uid'));
        const status = error?.response?.status;

        if (requestedUserId === sessionUserId && (status === 401 || status === 403 || status === 404)) {
            yield put(logout());
        }

        yield put(getUserFail(error.message));
        yield put(setLoading(false));
    }
}
// ========================================
// 📥 SAGA - Récupérer tous les utilisateurs
// ========================================
export function* getAllUsersSaga(action) {
    const url = `${API_BASE_URL}/api/users`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_ALL_USERS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_ALL_USERS_SUCCESS');
        console.log('📥 Nombre d\'utilisateurs:', resp.data.length);
        console.groupEnd();

        yield put(getAllUsersSuccess(resp.data));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_ALL_USERS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllUsersFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la récupération des utilisateurs");
    }
}

// ========================================
// 📥 SAGA - Récupérer utilisateurs par statut
// ========================================
export function* getUsersByStatusSaga(action) {
    const url = `${API_BASE_URL}/api/users/status/${action.payload.status}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_USERS_BY_STATUS_REQUEST');
        console.log('📊 Statut:', action.payload.status);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_USERS_BY_STATUS_SUCCESS');
        console.log('📥 Nombre d\'utilisateurs:', resp.data.length);
        console.groupEnd();

        yield put(getUsersByStatusSuccess(resp.data));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_USERS_BY_STATUS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getUsersByStatusFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la récupération");
    }
}

// ========================================
// 📥 SAGA - Récupérer utilisateurs par job
// ========================================
export function* getUsersByJobSaga(action) {
    const url = `${API_BASE_URL}/api/users/job/${action.payload.jobId}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_USERS_BY_JOB_REQUEST');
        console.log('📊 Job ID:', action.payload.jobId);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_USERS_BY_JOB_SUCCESS');
        console.log('📥 Nombre d\'utilisateurs:', resp.data.length);
        console.groupEnd();

        yield put(getUsersByJobSuccess(resp.data));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_USERS_BY_JOB_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getUsersByJobFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la récupération");
    }
}

// ========================================
// 📥 SAGA - Récupérer utilisateurs par entité
// ========================================
export function* getUsersByEntitySaga(action) {
    const url = `${API_BASE_URL}/api/users/entity/${action.payload.entityId}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 GET_USERS_BY_ENTITY_REQUEST');
        console.log('📊 Entity ID:', action.payload.entityId);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_USERS_BY_ENTITY_SUCCESS');
        console.log('📥 Nombre d\'utilisateurs:', resp.data.length);
        console.groupEnd();

        yield put(getUsersByEntitySuccess(resp.data));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_USERS_BY_ENTITY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getUsersByEntityFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la récupération");
    }
}

// ========================================
// ➕ SAGA - Créer un utilisateur
// ========================================
export function* createUserSaga(action) {
    const url = `${API_BASE_URL}/api/users`;
    const data = action.payload;
    const rawToken = sessionStorage.getItem("token");
    const token = rawToken?.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 CREATE_USER_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group('✅ CREATE_USER_SUCCESS');
        console.log('📥 Utilisateur créé:', resp.data);
        console.groupEnd();

        yield put(createUserSuccess(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: resp.data?.accountStatusReason || "Utilisateur créé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        // Redirection optionnelle
        if (action.history) {
            yield put(push('/users'));
        }

    } catch (error) {
        const message = extractErrorMessage(error, "Erreur lors de la création");
        console.group('❌ CREATE_USER_FAIL');
        console.error('🚨 Erreur:', error.response?.data || error);
        console.groupEnd();

        yield put(createUserFail(message));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: message,
            timer: 2500,
            showConfirmButton: false
        });
    }
}

// ========================================
// ✏️ SAGA - Mettre à jour un utilisateur
// ========================================
export function* updateUserSaga(action) {
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}`;
    const data = action.payload.userData;
    yield put(setLoading(true));

    try {
        console.group('🔵 UPDATE_USER_REQUEST');
        console.log('📊 User ID:', action.payload.userId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data });

        console.group('✅ UPDATE_USER_SUCCESS');
        console.log('📥 Utilisateur mis à jour:', resp.data);
        console.groupEnd();

        yield put(updateUserSuccess(resp.data));
        yield put(setLoading(false));

        // toast.success("Utilisateur mis à jour avec succès");

    } catch (error) {
        console.group('❌ UPDATE_USER_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateUserFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la mise à jour");
    }
}

export function* updateUserAccountStatusSaga(action) {
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}/account-status`;
    const data = action.payload.data;
    yield put(setLoading(true));

    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateUserAccountStatusSuccess(resp.data));
        yield put(getAllUsersRequest());
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: resp.data?.accountStatusReason || 'Statut du compte mis à jour avec succès',
            timer: 5000,
            showConfirmButton: false
        });
    } catch (error) {
        const message = extractErrorMessage(error, "Erreur lors de la mise à jour du statut du compte");
        yield put(updateUserAccountStatusFail(message));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: message,
            timer: 2600,
            showConfirmButton: false
        });
    }
}

// ========================================
// 🗑️ SAGA - Supprimer un utilisateur
// ========================================
export function* deleteUserSaga(action) {
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}`;
    yield put(setLoading(true));

    try {
        console.group('🔵 DELETE_USER_REQUEST');
        console.log('📊 User ID:', action.payload.userId);
        console.groupEnd();

        yield call(deleteRequest, { url });

        console.group('✅ DELETE_USER_SUCCESS');
        console.log('🗑️ Utilisateur supprimé');
        console.groupEnd();

        yield put(deleteUserSuccess(action.payload.userId));
        yield put(setLoading(false));

        // toast.success("Utilisateur supprimé avec succès");

        // Redirection optionnelle
        if (action.history) {
            yield put(push('/users'));
        }

    } catch (error) {
        console.group('❌ DELETE_USER_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(deleteUserFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors de la suppression");
    }
}

// ========================================
// 🎭 SAGA - Assigner des rôles
// ========================================
export function* assignRolesSaga(action) {
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}/roles`;
    const data = action.payload.roleIds;
    yield put(setLoading(true));

    try {
        console.group('🔵 ASSIGN_ROLES_REQUEST');
        console.log('📊 User ID:', action.payload.userId);
        console.log('📊 Role IDs:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data });

        console.log('✅ Rôles assignés avec succès');

        yield put(assignRolesSuccess(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Rôles assignés avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ ASSIGN_ROLES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(assignRolesFail(error.message));
        yield put(setLoading(false));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de l'assignation des rôles",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

// ========================================
// 🎭 SAGA - Retirer des rôles
// ========================================
export function* removeRolesSaga(action) {
    const url = `${API_BASE_URL}/api/users/${action.payload.userId}/roles`;
    const data = action.payload.roleIds;
    yield put(setLoading(true));

    try {
        console.group('🔵 REMOVE_ROLES_REQUEST');
        console.log('📊 User ID:', action.payload.userId);
        console.log('📊 Role IDs:', data);
        console.groupEnd();

        yield call(deleteRequest, { url, data });

        console.log('✅ Rôles retirés avec succès');

        yield put(removeRolesSuccess());
        yield put(setLoading(false));
        // toast.success("Rôles retirés avec succès");

    } catch (error) {
        console.group('❌ REMOVE_ROLES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(removeRolesFail(error.message));
        yield put(setLoading(false));
        // toast.error("Erreur lors du retrait");
    }
}
export function* getDirectReportsSaga(action) {
    const { managerId } = action.payload;
    const url = `${API_BASE_URL}/api/users/${managerId}/direct-reports`;

    yield put(setLoading(true));

    try {
        console.group('🔵 GET_DIRECT_REPORTS_REQUEST');
        console.log('👤 Manager ID:', managerId);
        console.log('🌐 URL:', url);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_DIRECT_REPORTS_SUCCESS');
        console.log('📥 Collaborateurs:', resp.data?.length || 0);
        console.groupEnd();

        yield put(getDirectReportsSuccess(resp.data || []));
        yield put(setLoading(false));

    } catch (error) {
        console.group('❌ GET_DIRECT_REPORTS_FAIL');
        console.error('🚨 Erreur:', error?.message);
        console.groupEnd();

        yield put(getDirectReportsFail(error?.message || "Erreur"));
        yield put(setLoading(false));
    }
}

export function* updateMyProfileSaga(action) {
    const { userId, data } = action.payload;
    const url = `${API_BASE_URL}/api/users/${userId}/profile`;

    yield put(setLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });

        yield put(updateMyProfileSuccess(resp.data));
        yield put(setAuthenticatedUser(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Profil mis à jour avec succès',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || error.message;
        yield put(updateMyProfileFail(msg));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: msg || 'Erreur lors de la mise à jour',
            timer: 2500,
            showConfirmButton: false,
        });
    }
}

export function* uploadUserPhotoSaga(action) {
    const { userId, file, photoType } = action.payload;
    const url = `${API_BASE_URL}/api/users/${userId}/photo?type=${photoType}`;

    const formData = new FormData();
    formData.append('file', file);

    yield put(setLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: formData,
            // Ne pas forcer Content-Type : axios le gère automatiquement avec FormData (boundary)
        });

        yield put(uploadUserPhotoSuccess(resp.data));
        yield put(setAuthenticatedUser(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: photoType === 'profile' ? 'Photo de profil mise à jour' : 'Bannière mise à jour',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || error.message;
        yield put(uploadUserPhotoFail(msg));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: msg || "Erreur lors de l'upload",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}

export function* deleteUserPhotoSaga(action) {
    const { userId, photoType } = action.payload;
    const url = `${API_BASE_URL}/api/users/${userId}/photo?type=${photoType}`;

    yield put(setLoading(true));
    try {
        const resp = yield call(deleteRequest, { url });

        yield put(deleteUserPhotoSuccess(resp.data));
        yield put(setAuthenticatedUser(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: photoType === 'profile' ? 'Photo de profil supprimée' : 'Bannière supprimée',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || error.message;
        yield put(deleteUserPhotoFail(msg));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: msg || "Erreur lors de la suppression",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}

export function* uploadAttestationRibSaga(action) {
    const { userId, file } = action.payload;
    const url = `${API_BASE_URL}/api/users/${userId}/attestation-rib`;

    const formData = new FormData();
    formData.append('file', file);

    yield put(setLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: formData,
        });

        yield put(uploadAttestationRibSuccess(resp.data));
        yield put(setAuthenticatedUser(resp.data));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Attestation de RIB mise a jour',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || error.message;
        yield put(uploadAttestationRibFail(msg));
        yield put(setLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: msg || "Erreur lors de l'upload",
            timer: 2500,
            showConfirmButton: false,
        });
    }
}
export function* exportUsersSaga() {
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");

    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/users/export-excel`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });

        downloadBlob(new Blob([res.data]), "export_users.xlsx");
        yield put({ type: EXPORT_USERS_SUCCESS });
    } catch (e) {
        yield put({ type: EXPORT_USERS_FAIL, payload: e.response?.data || e.message });
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: "L'exportation des utilisateurs a échoué" });
    }
}
